/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isObject = isObject;
exports.isNumber = isNumber;
exports.isPositiveNumber = isPositiveNumber;
exports.isInt = isInt;
exports.isPositiveInt = isPositiveInt;
exports.isString = isString;
exports.isNonEmptyString = isNonEmptyString;
exports.arePositiveNumbers = arePositiveNumbers;
exports.round = round;
exports.sameAbs = sameAbs;
exports.randomFloat = randomFloat;
exports.normalizeAngle = normalizeAngle;
exports.radToDeg = radToDeg;
exports.distanceToDuration = distanceToDuration;
exports.log = log;
exports.logWarning = logWarning;
exports.logError = logError;
exports.byID = byID;
exports.isHTMLElement = isHTMLElement;
exports.flush = flush;
exports.forfor = forfor;
exports.anyKeyBeingPressed = anyKeyBeingPressed;
exports.anyMouseButtonBeingPressed = anyMouseButtonBeingPressed;
exports.anyInputBeingPressed = anyInputBeingPressed;
exports.isMouseButton = isMouseButton;
exports.isKeyList = isKeyList;
exports.isFKey = isFKey;
var typeOf = function (global) {
    return function (obj) {
        if (obj === global) {
            return "global";
        }
        return {}.toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
    };
}(undefined);

var CONSOLE_PREFIX = "[Zatacka] ";

var KEY = exports.KEY = Object.freeze({ BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, PAUSE: 19, CAPS_LOCK: 20, ESCAPE: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT_ARROW: 37, UP_ARROW: 38, RIGHT_ARROW: 39, DOWN_ARROW: 40, INSERT: 45, DELETE: 46, "0": 48, "1": 49, "2": 50, "3": 51, "4": 52, "5": 53, "6": 54, "7": 55, "8": 56, "9": 57, A: 65, B: 66, C: 67, D: 68, E: 69, F: 70, G: 71, H: 72, I: 73, J: 74, K: 75, L: 76, M: 77, N: 78, O: 79, P: 80, Q: 81, R: 82, S: 83, T: 84, U: 85, V: 86, W: 87, X: 88, Y: 89, Z: 90, LEFT_META: 91, RIGHT_META: 92, SELECT: 93, NUMPAD_0: 96, NUMPAD_1: 97, NUMPAD_2: 98, NUMPAD_3: 99, NUMPAD_4: 100, NUMPAD_5: 101, NUMPAD_6: 102, NUMPAD_7: 103, NUMPAD_8: 104, NUMPAD_9: 105, MULTIPLY: 106, ADD: 107, SUBTRACT: 109, DECIMAL: 110, DIVIDE: 111, F1: 112, F2: 113, F3: 114, F4: 115, F5: 116, F6: 117, F7: 118, F8: 119, F9: 120, F10: 121, F11: 122, F12: 123, NUM_LOCK: 144, SCROLL_LOCK: 145, SEMICOLON: 186, EQUALS: 187, COMMA: 188, DASH: 189, PERIOD: 190, FORWARD_SLASH: 191, GRAVE_ACCENT: 192, OPEN_BRACKET: 219, BACK_SLASH: 220, CLOSE_BRACKET: 221, SINGLE_QUOTE: 222 });

var MOUSE = exports.MOUSE = Object.freeze(function () {
    var offset = 1000;
    return Object.freeze({
        unpack: function unpack(offseted) {
            return offseted - offset;
        },
        pack: function pack(standard) {
            return standard + offset;
        },
        LEFT: offset + 0,
        RIGHT: offset + 2,
        MIDDLE: offset + 1,
        MOUSE4: offset + 3,
        MOUSE5: offset + 4
    });
}());

var F_KEYS = exports.F_KEYS = Object.freeze([KEY.F1, KEY.F2, KEY.F3, KEY.F4, KEY.F5, KEY.F6, KEY.F7, KEY.F8, KEY.F9, KEY.F10, KEY.F11, KEY.F12]);

var MOUSE_BUTTONS = exports.MOUSE_BUTTONS = Object.freeze([MOUSE.LEFT, MOUSE.RIGHT, MOUSE.MIDDLE, MOUSE.MOUSE4, MOUSE.MOUSE5]);

function isObject(obj) {
    return typeOf(obj) === "object";
}

function isNumber(n) {
    return typeOf(n) === "number";
}

function isPositiveNumber(n) {
    return isNumber(n) && n > 0;
}

function isInt(n) {
    return isNumber(n) && n % 1 === 0;
}

function isPositiveInt(n) {
    return isInt(n) && n > 0;
}

function isString(s) {
    return typeOf(s) === "string";
}

function isNonEmptyString(s) {
    return isString(s) && s.length > 0;
}

function arePositiveNumbers(numbers) {
    return numbers.every(isPositiveNumber);
}

function round(number, decimals) {
    return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

function sameAbs(a, b) {
    return Math.abs(a) === Math.abs(b);
}

/**
 * Generates a random float between min (inclusive) and max (exclusive).
 *
 * @param {Number} min
 *   Minimum value (inclusive).
 * @param {Number} max
 *   Maximum value (exclusive).
 */
function randomFloat(min, max) {
    return Math.random() * (max - min) + min;
}

function normalizeAngle(a) {
    var pi = Math.PI;
    var angle = a % (2 * pi);
    angle = (angle + 2 * pi) % (2 * pi);
    if (angle > pi) {
        angle = angle - 2 * pi;
    }
    return angle;
}

function radToDeg(radians) {
    return 180 / Math.PI * radians;
}

function distanceToDuration(distance, velocity) {
    return distance / velocity * 1000; // milliseconds
}

function log(str) {
    console.log(CONSOLE_PREFIX + str);
}

function logWarning(str) {
    console.warn(CONSOLE_PREFIX + str);
}

function logError(str) {
    console.error(CONSOLE_PREFIX + str);
}

function byID(id) {
    return document.getElementById(id);
}

function isHTMLElement(elem) {
    return elem instanceof HTMLElement;
}

function flush(node) {
    if (isHTMLElement(node)) {
        node.textContent = "";
    } else {
        throw new TypeError(node + " is not a DOM node.");
    }
}

function forfor(y_start, y_end, x_start, x_end, func, arg) {
    for (var y = y_start; y < y_end; y++) {
        for (var x = x_start; x < x_end; x++) {
            func.call(this, x, y, arg);
        }
    }
}

var Keyboard = exports.Keyboard = {
    pressed: {},
    isDown: function isDown(keyCode) {
        return !!this.pressed[keyCode];
    },
    onKeydown: function onKeydown(event) {
        this.pressed[event.keyCode] = true;
    },
    onKeyup: function onKeyup(event) {
        delete this.pressed[event.keyCode];
    },
    reset: function reset() {
        this.pressed = {};
    }
};

var Mouse = exports.Mouse = {
    pressed: {},
    isDown: function isDown(mouseButtonNumber) {
        return this.pressed[mouseButtonNumber];
    },
    onMousedown: function onMousedown(event) {
        this.pressed[event.button] = true;
    },
    onMouseup: function onMouseup(event) {
        delete this.pressed[event.button];
    },
    reset: function reset() {
        this.pressed = {};
    }
};

function anyKeyBeingPressed(keyCodes) {
    return Array.isArray(keyCodes) && keyCodes.some(Keyboard.isDown, Keyboard);
}

function anyMouseButtonBeingPressed(mouseButtons) {
    return Array.isArray(mouseButtons) && mouseButtons.map(MOUSE.unpack).some(Mouse.isDown, Mouse);
}

function anyInputBeingPressed(keysOrMouseButtons) {
    return anyKeyBeingPressed(keysOrMouseButtons) || anyMouseButtonBeingPressed(keysOrMouseButtons);
}

function isMouseButton(button) {
    return isPositiveInt(button) && Object.keys(MOUSE).some(function (buttonName) {
        return MOUSE.hasOwnProperty(buttonName);
    });
}

function isKeyList(keys) {
    return Array.isArray(keys) && keys.length > 0 && keys.every(isPositiveInt);
}

function isFKey(key) {
    return F_KEYS.includes(key);
}

var PLATFORM = exports.PLATFORM = function () {
    var strings = {
        os_id_windows: "Win",
        os_id_mac: "Mac",
        os_id_linux: "Linux",
        os_id_unix: "X11",

        os_name_windows: "Windows",
        os_name_mac: "Mac",
        os_name_linux: "Linux",
        os_name_unix: "UNIX",
        os_name_unknown: "Unknown"
    };

    return {
        getOS: function getOS() {
            var ua = window.navigator.userAgent || window.navigator.appVersion;
            if (isNonEmptyString(ua)) {
                if (ua.indexOf(strings.os_id_windows) > -1) {
                    return strings.os_name_windows;
                }
                if (ua.indexOf(strings.os_id_mac) > -1) {
                    return strings.os_name_mac;
                }
                if (ua.indexOf(strings.os_id_linux) > -1) {
                    return strings.os_name_linux;
                }
                if (ua.indexOf(strings.os_id_unix) > -1) {
                    return strings.os_name_unix;
                }
            }
            return strings.os_name_unknown;
        },
        getFullscreenShortcut: function getFullscreenShortcut() {
            switch (PLATFORM.getOS()) {
                case strings.os_name_mac:
                    return "mac";
                    break;
                default:
                    return "default";
            }
        }
    };
}();

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

exports.default = function () {
        var KEY_SHIFT = "⇧";
        var KEY_CMD = "⌘";
        var KEY_PROCEED = "Space or Enter";
        var KEY_QUIT = "Esc";

        return Object.freeze({
                hint_start: "Press <kbd>Space</kbd> to start",
                hint_popup: "It is recommended to run Kurve in its own window without history (to avoid switching tabs or navigating back in history mid-game). Click here to do so.",
                hint_pick: "Pick your desired color by pressing the corresponding LEFT key (e.g. M for Orange).",
                hint_proceed: "Press " + KEY_PROCEED + " to start!",
                hint_next: "Press " + KEY_PROCEED + " to proceed, or " + KEY_QUIT + " to quit.",
                hint_quit: "Press " + KEY_PROCEED + " to start over.",
                hint_alt: "Alt plus some other keys may cause undesired behavior (e.g. switching windows).",
                hint_ctrl: "Ctrl plus some other keys may cause undesired behavior (e.g. closing the tab).",
                hint_mouse: "Make sure to keep the mouse cursor inside the browser window.",
                hint_preferences_access_denied: "Could not save/load settings because access to localStorage was denied by the browser. This might be caused by \"third-party site data\" being blocked or similar.",

                keyboard_fullscreen_mac: "<kbd>" + KEY_CMD + " + Ctrl + F</kbd> and/or <kbd>" + KEY_CMD + " + " + KEY_SHIFT + " + F</kbd>",
                keyboard_fullscreen_standard: "<kbd>F11</kbd>",

                getFullscreenHint: function getFullscreenHint(shortcut) {
                        return "Press " + shortcut + " to toggle fullscreen";
                },

                label_button_alert_ok: "OK",
                label_button_confirm_yes: "Yes",
                label_button_confirm_no: "No",

                label_text_confirm_quit: "Are you sure you want to quit?",
                label_text_confirm_reload: "Are you sure you want to reload the application?",

                pref_label_cursor: "Mouse pointer",
                pref_label_description_cursor: "Control how the pointer behaves when the game is live. (It is always visible in the menu.) \"Used by player\" means that a player is using the mouse to control their Kurve.",
                pref_label_cursor_always_visible: "Always visible",
                pref_label_cursor_hidden_when_mouse_used_by_player: "Hidden when mouse used by player",
                pref_label_cursor_always_hidden: "Always hidden",

                pref_label_edge_fix: "Invisible border fix",
                pref_label_description_edge_fix: "Shrink the playing field slightly to make the gray border visible if the monitor is exactly the same height and/or width as the game (in pixels).",
                pref_label_edge_fix_off: "Off",
                pref_label_edge_fix_minimal: "Minimal",
                pref_label_edge_fix_full: "Full",

                pref_label_hints: "Messages",
                pref_label_description_hints: "Hints (white text) are unnecessary for experienced Kurve players. Warnings (yellow) can be useful for players new to playing Kurve in the browser.",
                pref_label_hints_all: "Hints and warnings",
                pref_label_hints_warnings_only: "Warnings only",
                pref_label_hints_none: "None",

                pref_label_prevent_spawnkill: "Prevent spawnkills",
                pref_label_description_prevent_spawnkill: "Enforce a minimum distance between players at round start.",

                pref_label_confirm_quit: "Confirm quit",
                pref_label_description_confirm_quit: "Ask for confirmation before quitting to the main menu (Esc) or reloading the application (F5).",

                pref_label_scaling: "Scaling",
                pref_label_description_scaling: "Visual quality ensures a crisp, pixelmapped image. On-screen size may result in blurry graphics and other visual errors, but can be useful if the game is very small on your screen.",
                pref_label_scaling_prefer_quality: "Prefer visual quality",
                pref_label_scaling_prefer_size: "Prefer on-screen size"
        });
}();

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Object.freeze({
    game_url: "ZATACKA.html",

    error_name_security: "SecurityError",

    class_hidden: "hidden",
    class_active: "active",
    class_dialog: "dialog",
    class_dialog_alert: "alert",
    class_dialog_confirmation: "confirmation",
    class_description: "description",
    class_half_width: "half-width",
    class_right_hand_side: "right-hand-side",
    class_blurry: "blurry",
    class_nocursor: "nocursor",
    class_tempcursor: "tempcursor",
    class_hints_warnings_only: "hints-warnings-only",
    class_hints_none: "hints-none",
    html_name_preference_prefix: "preference-",

    cursor_hidden: "hidden",
    cursor_visible: "visible",

    id_start_hint: "start-hint",
    id_fullscreen_hint: "fullscreen-hint",
    id_button_show_settings: "button-show-settings",
    id_button_hide_settings: "button-hide-settings",

    pref_number_type_integer: "integer",
    pref_number_type_float: "float",

    pref_key_cursor: "cursor",
    pref_value_cursor_always_visible: "always_visible",
    pref_value_cursor_hidden_when_mouse_used_by_player: "hidden_when_mouse_used_by_player",
    pref_value_cursor_always_hidden: "always_hidden",

    pref_key_edge_fix: "edge_fix",
    pref_value_edge_fix_full: "full",
    pref_value_edge_fix_minimal: "minimal",
    pref_value_edge_fix_off: "off",

    pref_key_hints: "hints",
    pref_value_hints_all: "all",
    pref_value_hints_warnings_only: "warnings",
    pref_value_hints_none: "none",

    pref_key_confirm_quit: "confirm_quit",
    pref_key_confirm_reload: "confirm_reload",
    pref_key_prevent_spawnkill: "prevent_spawnkill",

    pref_key_scaling: "scaling",
    pref_value_scaling_prefer_quality: "prefer_quality",
    pref_value_scaling_prefer_size: "prefer_size"
});

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _utilities = __webpack_require__(0);

var _strings = __webpack_require__(2);

var _strings2 = _interopRequireDefault(_strings);

var _ZatackaEn_US = __webpack_require__(1);

var _ZatackaEn_US2 = _interopRequireDefault(_ZatackaEn_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
    var PROCEED_KEYS = Object.freeze([_utilities.KEY.SPACE, _utilities.KEY.ENTER]);

    function isProceedKey(key) {
        return PROCEED_KEYS.some(function (proceedKey) {
            return proceedKey === key;
        });
    }

    function proceedToGame() {
        var newWindow = window.open(_strings2.default.game_url);
        if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
            // Browser is blocking popups.
            window.location.href = _strings2.default.game_url;
        }
    }

    function splashScreenKeyHandler(event) {
        var pressedKey = event.keyCode;
        if (isProceedKey(pressedKey)) {
            proceedToGame();
        }
    }

    function showStartHint() {
        var startHintElement = (0, _utilities.byID)(_strings2.default.id_start_hint);
        if ((0, _utilities.isHTMLElement)(startHintElement)) {
            startHintElement.innerHTML = _ZatackaEn_US2.default.hint_start;
        }
    }

    function showFullscreenHint() {
        var fullscreenHintElement = (0, _utilities.byID)(_strings2.default.id_fullscreen_hint);
        if ((0, _utilities.isHTMLElement)(fullscreenHintElement)) {
            var fullscreenShortcut = _utilities.PLATFORM.getFullscreenShortcut() === "mac" ? _ZatackaEn_US2.default.keyboard_fullscreen_mac : _ZatackaEn_US2.default.keyboard_fullscreen_standard;
            fullscreenHintElement.innerHTML = _ZatackaEn_US2.default.getFullscreenHint(fullscreenShortcut);
        }
    }

    function addEventListeners() {
        document.addEventListener("keydown", splashScreenKeyHandler);
        document.addEventListener("DOMContentLoaded", showStartHint);
        document.addEventListener("DOMContentLoaded", showFullscreenHint);
    }

    addEventListeners();
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// splashscreen.min.js